// extracted by mini-css-extract-plugin
module.exports = {"wrapperCount":"CountData_wrapperCount__1auqS"};